import React from "react";
import VisionMission from "../pages/VisionMission";
import Testimonialabout from "../pages/Testimonialabout";

const About = () => {
  return (
    <>
      {/* Breadcrumb */}
      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="wow fadeInUp text-center" data-wow-delay=".5s">
              About Royal Route Cab
            </h1>
          </div>
        </div>
      </div>

      {/* About Section */}
      <section className="about-section section-padding sect-bg">
        <div className="shape-1">
          <img src="/img/about/dot-shape.png" alt="shape" />
        </div>

        <div className="container">
          <div className="about-wrapper">
            <div className="row g-4 align-items-center">

              {/* Left Image */}
              <div className="col-lg-5">
                <div className="about-image wow img-custom-anim-left">
                  <img src="/images/about.png" alt="Royal Route Cab" />
{/* 
                  <div className="about-box float-bob-y">
                    <h2>
                      <span className="odometer" data-count="10">00</span>+
                    </h2>
                    <p>YEARS OF TRUSTED SERVICE</p>
                  </div> */}
                </div>
              </div>

              {/* Right Content */}
              <div className="col-lg-7">
                <div className="about-content">

                  {/* Title */}
                  <div className="section-title">
                    <span className="wow fadeInUp">About Royal Route Cab</span>

                    <h2 className="wow fadeInUp text-dark" data-wow-delay=".3s">
                      Your Trusted Partner for Safe & Comfortable Travel
                    </h2>
                  </div>

                  {/* Paragraph 1 */}
                  <p
                    className="wow fadeInUp mt-4 mt-md-0"
                    data-wow-delay=".5s"
                  >
                    Royal Route Cab is a professional and reliable cab service provider
                    dedicated to offering safe, comfortable, and affordable travel solutions.
                    We specialize in local rides, airport transfers, outstation trips,
                    corporate travel, and event transportation with well-maintained vehicles
                    and experienced drivers.
                  </p>

                  {/* Paragraph 2 */}
                  <p
                    className="wow fadeInUp mt-3"
                    data-wow-delay=".6s"
                  >
                    Our mission is to make every journey smooth, punctual, and stress-free.
                    With 24x7 availability, transparent pricing, and customer-first service,
                    Royal Route Cab ensures a premium travel experience for families,
                    professionals, and business travelers across cities.
                  </p>

                  {/* Highlight Quote */}
                  <div
                    className="about-sideber wow fadeInUp"
                    data-wow-delay=".3s"
                  >
                    <h5>
                      “We don’t just provide rides — we deliver trust, safety, and comfort in every journey.”
                    </h5>
                  </div>

                  {/* Features List */}
                  <div className="about-icon-items">

                    <ul className="wow fadeInUp" data-wow-delay=".3s">
                      <li>✔ Experienced & Professional Drivers</li>
                      <li>✔ 24x7 Cab Service Availability</li>
                      <li>✔ Clean & Well-Maintained Cars</li>
                    </ul>

                    <ul className="wow fadeInUp" data-wow-delay=".5s">
                      <li>✔ Affordable & Transparent Pricing</li>
                      <li>✔ Easy WhatsApp Booking System</li>
                      <li>✔ Pan India Travel Support</li>
                    </ul>

                  </div>

                

                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      <VisionMission/>
      <Testimonialabout/>
    </>
  );
};

export default About;